var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.06 56.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #04263d;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    className: "cls-1",
    cx: 28.03,
    cy: 28.03,
    r: 28.03
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m38.44,43.02h-20.82c-2.53,0-4.58-2.05-4.58-4.58v-20.82c0-2.53,2.05-4.58,4.58-4.58h20.82c2.53,0,4.58,2.05,4.58,4.58v20.82c0,2.53-2.05,4.58-4.58,4.58ZM17.62,15.54c-1.15,0-2.08.93-2.08,2.08v20.82c0,1.15.93,2.08,2.08,2.08h20.82c1.15,0,2.08-.93,2.08-2.08v-20.82c0-1.15-.93-2.08-2.08-2.08h-20.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m21.78,36.36c-.69,0-1.25-.56-1.25-1.25v-9.16c0-.69.56-1.25,1.25-1.25s1.25.56,1.25,1.25v9.16c0,.69-.56,1.25-1.25,1.25Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 21.78,
    cy: 21.37,
    r: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m34.28,36.36c-.69,0-1.25-.56-1.25-1.25v-5.41c0-1.38-1.12-2.5-2.5-2.5s-2.5,1.12-2.5,2.5v5.41c0,.69-.56,1.25-1.25,1.25s-1.25-.56-1.25-1.25v-5.41c0-2.75,2.24-5,5-5s5,2.24,5,5v5.41c0,.69-.56,1.25-1.25,1.25Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.87ef81eb08243dec0fd6ef26aa951fa7.svg";
export { ForwardRef as ReactComponent };